// extracted by mini-css-extract-plugin
module.exports = {"card":"card_card__SUaz3","image":"card_image___BXzq","footer":"card_footer__YT2nM"};